import * as React from "react";
import { Image, makeStyles } from "@fluentui/react-components";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

export interface HeaderProps {
  title: string;
  logo: string;
  isInitialized: boolean;
  oktaIdToken?: string;
  userID: string;
  userName: string;
  identityProvider: string;
  setIsInitialized: (isInitialized: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  userChanged: (token: string, oktaIdToken: string, ID: string, name: string) => void;
  userRemoved: () => void;
  errorRaised: (message: string) => void;
}

const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundColor: "#f0f0f0",
    height: "40px",
  },
  rightPane: {
    display: "flex",
    justifyContent: "right",
  },
});

const Header: React.FC<HeaderProps> = ({
  title,
  logo,
  isInitialized,
  oktaIdToken,
  userID,
  userName,
  identityProvider,
  setIsInitialized,
  setIsLoading,
  userChanged,
  userRemoved,
  errorRaised,
}) => {
  const styles = useStyles();

  return (
    <section className={styles.welcome__header}>
      <Image src={logo} alt={title} style={{ maxHeight: "30px", maxWidth: "175px" }} />
      <div>
        {!userID ? (
          <LoginButton
            isInitialized={isInitialized}
            setIsInitialized={setIsInitialized}
            setIsLoading={setIsLoading}
            userChanged={userChanged}
            errorRaised={errorRaised}
          />
        ) : (
          <div>
            <div style={{ maxWidth: "clamp(96px, 30vw, 500px)", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              <span title={userID}>{userName}</span>
            </div>
            <div className={styles.rightPane}>
              <LogoutButton oktaIdToken={oktaIdToken} setIsLoading={setIsLoading} userRemoved={userRemoved} identityProvider={identityProvider}/>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Header;
